/* @generated */

// src/mini/magnifying-glass.tsx
import * as React from "react";

// src/index.css.ts
var miniIllustrationStyle = "dig-13or4mr0_4-3-0";

// src/mini/magnifying-glass.tsx
var MagnifyingGlassMini = ({ altText, ...rest }) => {
  const classNames = `dig-Illustration ${miniIllustrationStyle} dig-Illustration-mini`;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      role: "presentation",
      ...rest,
      className: classNames,
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("title", null, altText),
    /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M47.271 32.212c-3.465 2.113-5.313 5.634-4.028 7.672 1.47 2.332 2.49 2.142 5.815-1.089 3.389-3.29 3.892-3.489 5.796-2.284 1.642 1.04.614 3.42-1.89 4.373-4.121 1.566-6.139 8.008-3.124 9.967 1.806 1.172 4.23-.544 4.23-2.996 0-.904.569-1.643 1.264-1.643 2.296 0 5.644-3.868 6.226-7.194 1.208-6.896-7.41-11-14.289-6.806Zm1.89 23.123c-1.063 2.77.048 5.308 2.444 5.585 2.966.342 4.773-2.408 3.34-5.084-1.09-2.035-5.063-2.38-5.784-.5Z",
        fill: "currentColor"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M43.57 12.371c-28.17 6.59-36.965 38.397-16.674 60.32 7.105 7.676 24.86 11.546 36.76 8.013 3.862-1.147 4.833-1.184 5.717-.22.587.64 7.467 9.137 15.291 18.883 8.145 10.144 10.969 14.218 15.66 17.706 5.809.887 7.997-3.321 7.997-7.307 0-1.621-16.142-25.552-21.917-32.493-4.363-5.245-4.722-6.885-2.31-10.578C96.806 47.219 87.812 20.78 66.076 13.73c-6.904-2.239-16.314-2.807-22.505-1.359Zm17.938 12.74c16.048 7.393 18.575 30.784 4.375 40.483-15.347 10.484-36.885-.476-37.12-18.888-.21-16.307 18.064-28.358 32.745-21.595Z",
        fill: "#C8AFF0"
      }
    ))
  );
};
export {
  MagnifyingGlassMini
};
